module.exports = __webpack_public_path__ + "img/be.63fd03cf.svg";